<template>
  <section class="fen-shi-dan-liang">
    <PageBlock title="分时单量趋势图">
      <div class="content">
        <div ref="chart" style="width: 100%;height: 360px;"></div>
      </div>
    </PageBlock>
  </section>
</template>

<script>
import PageBlock from "@/components/page-block.vue";
import * as echarts from "echarts";

export default {
  name: 'fen-shi-dan-liang',
  components: {PageBlock},
  props: {
    timeOrderCountVoList: Array
  },
  watch: {
    timeOrderCountVoList: {
      handler: (val) => {
        this.chart.dispose()
        this.initChart()
      },
      immediate: true,
      deep: true,
    }
  },
  data() {
    return {
      chart: null,
    };
  },
  mounted() {
    this.initChart();
  },
  methods: {
    initChart() {
      this.chart = echarts.init(this.$refs.chart);
      const option = {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross',
            crossStyle: {
              color: '#999'
            }
          }
        },
        grid: {
          left: '40',
          bottom: 20
        },
        legend: {
          data: ['分时单量', '同比增长率'],
          textStyle: {
            color: '#fff'
          }
        },
        xAxis: [
          {
            type: 'category',
            data: this.timeOrderCountVoList.map(item => item.hour + ':00'),
            axisPointer: {
              type: 'shadow'
            }
          }
        ],
        yAxis: [
          {
            type: 'value',
            // name: '分时单量',
            // min: 0,
            // max: 250,
            // interval: 50,
            axisLabel: {
              formatter: '{value}',
              color: '#fff'
            },
            splitLine: {
              show: false
            },
          },
          {
            type: 'value',
            // name: '同比增长率',
            // min: 0,
            // max: 25,
            // interval: 5,
            axisLabel: {
              formatter: '{value}%',
              color: '#fff'
            },
            splitLine: {
              show: false
            }
          }
        ],
        series: [
          {
            name: '分时单量',
            type: 'bar',
            tooltip: {
              valueFormatter: function (value) {
                return value + '';
              }
            },
            data: this.timeOrderCountVoList.map(item => item.orderCount),
          },
          {
            name: '同比增长率',
            type: 'line',
            yAxisIndex: 1,
            tooltip: {
              valueFormatter: function (value) {
                return value + '';
              }
            },
            data: this.timeOrderCountVoList.map(item => parseFloat(item.growthRate)),
          }
        ]
      }
      // 设置配置项
      this.chart.setOption(option)
    },
  },
};
</script>

<style scoped>
.chan-pin-man-yi-du {
}
</style>
